import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { DollarSign } from 'lucide-react';
import { EnhancedFinancialSection } from './EnhancedFinancialSection';
import { LecturerSalarySection } from './LecturerSalarySection';
import { StudentTuitionSection } from './StudentTuitionSection';

export const FinancialSection = () => {
  return (
    <div className="space-y-6">
      <Card className="bg-card/50 border-border/50">
        <CardHeader>
          <div className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-primary" />
            <CardTitle className="text-muted-foreground">Ֆինանսական կառավարում</CardTitle>
          </div>
          <CardDescription className="text-muted-foreground">
            Բարելավված ֆինանսական համակարգ ավտոմատ տրամաբանությամբ
          </CardDescription>
        </CardHeader>
      </Card>

      <Tabs defaultValue="enhanced" className="w-full">
        <div className="-mx-1 mb-4 min-w-0 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <TabsList className="inline-flex h-auto min-w-max gap-1 border border-border/70 bg-muted/70 p-1.5 sm:grid sm:w-full sm:min-w-0 sm:grid-cols-3">
            <TabsTrigger value="enhanced" className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm">
              Ֆինանսական վերլուծություն
            </TabsTrigger>
            <TabsTrigger value="lecturer-salary" className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm">
              Դասախոսների աշխատավարձ
            </TabsTrigger>
            <TabsTrigger value="student-tuition" className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm">
              Ուսանողների վարձավճար
            </TabsTrigger>
          </TabsList>
        </div>


        <TabsContent value="enhanced">
          <EnhancedFinancialSection />
        </TabsContent>

        <TabsContent value="lecturer-salary">
          <LecturerSalarySection />
        </TabsContent>

        <TabsContent value="student-tuition">
          <StudentTuitionSection />
        </TabsContent>
      </Tabs>
    </div>
  );
};